import './style.scss';

export function call_to_action_block() {
    const block = document.querySelector('.call_to_action_block');
    if (!block) return;
}

